// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatChatListDrawer-modulechatListDrawer__AGbxX";
export { _1 as "chatListDrawer" }
